var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTipsAndUpdatesTwoTowned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 49H23.9167C23.9167 51.5667 21.8167 53.6667 19.25 53.6667C16.6833 53.6667 14.5833 51.5667 14.5833 49ZM36.75 24.5C36.75 33.4133 30.5433 38.1733 27.9533 39.6667H10.5467C7.95667 38.1733 1.75 33.4133 1.75 24.5C1.75 14.84 9.59 7 19.25 7C28.91 7 36.75 14.84 36.75 24.5ZM32.0833 24.5C32.0833 17.43 26.32 11.6667 19.25 11.6667C12.18 11.6667 6.41667 17.43 6.41667 24.5C6.41667 30.2633 9.89333 33.5767 11.9 35H26.6C28.6067 33.5767 32.0833 30.2633 32.0833 24.5Z",
    fill: "#617A85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9163 20.9997L48.113 19.5297L49.583 16.333L51.053 19.5297L54.2497 20.9997L51.053 22.4697L49.583 25.6663L48.113 22.4697L44.9163 20.9997Z",
    fill: "#FCBE1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7763 11.5263L42.583 16.333L40.3897 11.5263L35.583 9.33301L40.3897 7.13967L42.583 2.33301L44.7763 7.13967L49.583 9.33301L44.7763 11.5263Z",
    fill: "#FCBE1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2503 46.6667C10.967 46.6667 9.91699 45.6167 9.91699 44.3333C9.91699 43.05 10.967 42 12.2503 42H26.2503C27.5337 42 28.5837 43.05 28.5837 44.3333C28.5837 45.6167 27.5337 46.6667 26.2503 46.6667H12.2503Z",
    fill: "#617A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsAndUpdatesTwoTowned);
export default __webpack_public_path__ + "static/media/tipsAndUpdatesTwoTowned.ae565caf7c8605794c5bd419df1f8453.svg";
export { ForwardRef as ReactComponent };